import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import * as MessageActions from '../../common/messageBox/actions/actions';

export const fetchVehiclesHistoryColor = (masterCode, sfx) => {
  return apiActionCreator({
    'endpoint': `/master-vehicles/vehicle-color-combination/${masterCode}/${sfx}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_VEHICLES_HISTORY_COLORS,
      ActionTypes.FETCHED_VEHICLES_HISTORY_COLORS,
      [ActionTypes.FETCHED_VEHICLES_HISTORY_COLORS_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const fetchActiveColors = () =>
  apiActionCreator({
    'endpoint': '/master-vehicles/colors?status=A',
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_ACTIVE_COLORS,
      ActionTypes.FETCHED_ACTIVE_COLORS,
      [ActionTypes.FETCHED_ACTIVE_COLORS_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const updateVehiclesColor = (data) => (dispatch) => {
  const masterCode = (data && data.master) || '';
  const sfx = (data && data.sfx) || '';
  return dispatch(
    apiActionCreator({
      'endpoint': '/master-vehicles/vehicle-color-combination',
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_VEHICLES_HISTORY_COLORS,
        [
          () => {
            dispatch(fetchVehiclesHistoryColor(masterCode, sfx));
            return {
              'type': ActionTypes.UPDATED_VEHICLES_HISTORY_COLORS,
            };
          },
          (response) => MessageActions.addMessageBoxInfo(`Vehículo ${masterCode}/${sfx}: Color actualizado con éxito`),
          
        ],
        [ActionTypes.UPDATED_VEHICLES_HISTORY_COLORS_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'POST',
      'data': data,
    })
  );
};

export const createVehiclesColor = (data) => (dispatch) => {
  const masterCode = (data && data.master) || '';
  const sfx = (data && data.sfx) || '';
  return dispatch(
    apiActionCreator({
      'endpoint': '/master-vehicles/vehicle-color-combination',
      'authenticated': true,
      'types': [
        ActionTypes.CREATING_VEHICLES_HISTORY_COLORS,
        [
          () => {
            dispatch(fetchVehiclesHistoryColor(masterCode, sfx));
            return {
              'type': ActionTypes.CREATED_VEHICLES_HISTORY_COLORS,
            };
          },
          (response) => MessageActions.addMessageBoxInfo(`Vehículo ${masterCode}/${sfx}: Color creado con éxito`),
        ],
        [ActionTypes.CREATED_VEHICLES_HISTORY_COLORS_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'POST',
      'data': data,
    })
  );
};

export const changeVehiclesHistoryColorState = (key, value) => ({
  'type': ActionTypes.CHANGE_VEHICLES_HISTORY_COLOR_STATE,
  'payload': {'key': key, 'value': value},
});
